module.exports = __webpack_public_path__ + "static/media/image7.673df722.jpg";